import Vue from 'vue'
import VueRouter from 'vue-router'

import Profiles from '../components/Profiles'
import Add_Profile from '../components/Add_Profile'
import ChooseRole from '../components/ChooseRole'
import Driver_Home from '../components/Driver_Home'
import CheckInOut from '../components/CheckInOut'
import Warehouse_Home from '../components/Warehouse_Home'
import Delivery_Details from '../components/Delivery_Details'
import Distributor_Delivery from '../components/Distributor_Delivery'
import Authenticate from '../components/Authenticate'
import Signature from '../components/Signature'
import Review from '../components/Review'
import Complete from '../components/Complete'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: [
        {path:'/', name:'Home', component: Profiles},
        {path:'/Add_Profile', name:'Add_Profile', component: Add_Profile},
        {path:'/ChooseRole', name:'ChooseRole', component: ChooseRole},
        {path:'/Authenticate', name:'Authenticate', component: Authenticate},
        {path:'/Driver_Home', component: Driver_Home},
        {path:'/Warehouse_Home', name: 'Warehouse_Home', component: Warehouse_Home},
        {path:'/Delivery_Details', name: 'Delivery_Details', component: Delivery_Details},
        {path:'/Distributor_Delivery', name: 'Distributor_Delivery', component: Distributor_Delivery},
        {path:'/CheckInOut', component: CheckInOut},
        {path:'/Signature', component: Signature},
        {path:'/Review', component: Review},
        {path:'/Complete', component: Complete},
    ],
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js